
import React from "react";
import "./index.css"
import { request } from "../../utils/request"
import message from "antd/lib/message"
import i18n from "../../i18n";

export default class extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            deviceType: "",
            questionnaireList: [],
            formList: [],
            isSuccess: false
        }
    }

    componentDidMount() {
        console.log(this.props.match.params.token)
        console.log(this.props.match.params.meetKey)
        let u = navigator.userAgent;
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
        const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let deviceType = ""
        if (isAndroid) {
            deviceType = "android";
        } else if (isIOS) {
            deviceType = "ios";
        } else {
            //if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent))
            deviceType = "web";
        }
        this.setState({ deviceType: deviceType }, () => {
            this.getQuestionnaire()
        })
    }

    async getQuestionnaire() {
        const res = (await request.get(
            `/api/questionnaire/0/${this.state.deviceType}`, {
            headers: {
                'Authorization': 'Bearer ' + this.props.match.params.token
            }
        })).data;

        if (res.code === 200) {
            this.setState({ questionnaireList: res.data })
        }
    }

    async submit() {
        if (!this.state.formList.length) {
            message.warn(i18n.t('pEnterContent'))
            return
        }
        const res = (await request.post(
            `/api/questionnaire/research/${this.props.match.params.meetKey}`, this.state.formList, {
            headers: {
                'Authorization': 'Bearer ' + this.props.match.params.token
            }
        })).data;

        if (res.code === 200) {
            this.setState({ isSuccess: true })
            // window.parent.postMessage({  //参数是对象
            //     cmd: 'closeVoteModal',
            //     params: {
            //         success: true
            //     }
            // }, '*');
            // return
        }
    }

    render() {
        return <div className="votePage">
            {
                !this.state.isSuccess ? this.state.questionnaireList.map((ele, index) => {
                    return <div className="list-item" key={ele.primaryKey}>
                        <div className="title">{index + 1}.{ele.title}</div>
                        <div className="option">
                            {
                                ele.questionOptions.map(eleP => {
                                    return <p key={eleP.primaryKey}>
                                        {ele.type === 0 ? <input type='radio' name="category" value={eleP.questionValue}
                                            onClick={(e) => {
                                                const { formList } = this.state;
                                                const target = formList.filter(node => node.questionProblemId === ele.primaryKey)
                                                if (target.length) {
                                                    target[0].answers = [e.currentTarget.value]
                                                } else {
                                                    formList.push({
                                                        questionProblemId: ele.primaryKey,
                                                        answers: [e.currentTarget.value]
                                                    })
                                                }
                                            }} /> : ""}
                                        {ele.type === 1 ? <input type='checkbox' name="category" value={eleP.questionValue}
                                            onClick={(e) => {
                                                const { formList } = this.state;
                                                const value = e.currentTarget.value;
                                                const target = formList.filter(node => node.questionProblemId === ele.primaryKey)
                                                if (target.length) {
                                                    const index = target[0].answers.indexOf(value)
                                                    if (index === -1) {
                                                        target[0].answers.push(value)
                                                    } else {
                                                        target[0].answers.splice(index, 1)
                                                    }
                                                } else {
                                                    formList.push({
                                                        questionProblemId: ele.primaryKey,
                                                        answers: [e.currentTarget.value]
                                                    })
                                                }
                                                if (eleP.type === 1) {
                                                    eleP.select = true
                                                }
                                                this.setState({ questionnaireList: this.state.questionnaireList })
                                            }} /> : ""}
                                        <span className="questionValue"> {eleP.questionValue}</span>
                                        {eleP.type === 1 && eleP.select && <input type='input' name="category"
                                            onChange={(e) => {
                                                const { formList } = this.state;
                                                const value = e.currentTarget.value;
                                                const target = formList.filter(node => node.questionProblemId === ele.primaryKey)
                                                if (target.length) {
                                                    target[0].answers[1] = value
                                                }
                                            }} />}
                                    </p>
                                })
                            }
                            {
                                ele.type === 2 ? <input className='input' type='input' name="category" onBlur={(e) => {
                                    const { formList } = this.state;
                                    const value = e.currentTarget.value;
                                    const target = formList.filter(node => node.questionProblemId === ele.primaryKey)
                                    if (target.length) {
                                        target[0].answers = [value]
                                    } else {
                                        formList.push({
                                            questionProblemId: ele.primaryKey,
                                            answers: [value]
                                        })
                                    }
                                }} /> : ""
                            }
                        </div>
                    </div>
                }) : <div className="success">{i18n.t('ThankParticipation')}</div>
            }
            {
                !this.state.isSuccess && <div style={{ textAlign: "center" }}>
                    <div className="btn" onClick={this.submit.bind(this)}>{i18n.t('submit')}</div>
                </div>
            }
        </div>
    }
}